export default "__VITE_ASSET__jvhKx33L__"